import React, { useEffect, useState } from "react";

import { Trans, useTranslation } from "react-i18next";
import Select from "react-select";

import ValidationError from "../Shared/ValidationError";
import BaseModal from "./BaseModal";
import LookupsAPI from "../../API/lookups.api";
import { getReactSelectStyling } from "../../utils/ReactSelectStyles";

const ManageFirmwareModal = ({
    showModal,
    setShowModal,
    isModalSubmitting,
    data,
    setData,
    error,
    isFromSubmitted,
    submitFirmware,
}) => {
    const [scanners, setScanners] = useState([]);
    const [isFetchingScanners, setIsFetchingScanners] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        fetchScanners();
    }, []);

    const fetchScanners = async () => {
        const result = await LookupsAPI.getScanners(false);
        setScanners(result);
        setIsFetchingScanners(false);
    };

    const returnErrorMessages = (propName) => {
        return isFromSubmitted && error[propName];
    };

    const handleInputChange = (e) => {
        setData((prevParams) => {
            return {
                ...prevParams,
                [e.target.name]: e.target.value?.trim(),
            };
        });
    };

    const handleMultiSelect = (newValue, action) => {
        setData((prevData) => ({ ...prevData, [action.name]: newValue }));
    };

    const renderChildren = () => (
        <>
            <div
                className={`input-group ${
                    returnErrorMessages("devices")
                        ? "invalid-warning-input"
                        : ""
                }`}
            >
                <label className="uppercase required">
                    <Trans i18nKey="selectDevices">Select Devices</Trans>
                </label>
                <Select
                    isMulti
                    onChange={handleMultiSelect}
                    isModalSubmitting
                    styles={getReactSelectStyling({
                        showError: isFromSubmitted && error.devices,
                        isMultiSelect: true,
                    })}
                    value={data?.devices}
                    isSearchable
                    options={scanners}
                    isDisabled={isFetchingScanners}
                    isLoading={isFetchingScanners}
                    name="devices"
                />
                <ValidationError
                    errorMessage={returnErrorMessages("devices")}
                />
            </div>

            <div
                className={`input-group ${
                    returnErrorMessages("firmwareVersion")
                        ? "invalid-warning-input"
                        : ""
                }`}
            >
                <label className="uppercase required">
                    <Trans i18nKey="firmwareVersion">Firmware Version</Trans>
                </label>
                <input
                    className="input-element"
                    type="text"
                    name="firmwareVersion"
                    onChange={handleInputChange}
                    value={data?.firmwareVersion || ""}
                    placeholder={t("versionPlaceholder")}
                />
                <ValidationError
                    errorMessage={returnErrorMessages("firmwareVersion")}
                />
            </div>
        </>
    );

    return (
        <BaseModal
            isVisible={showModal}
            setIsVisible={setShowModal}
            isSubmitting={isModalSubmitting}
            titleIcon="fas fa-cog"
            title={t("manageFirmware")}
            action={{
                submitAction: submitFirmware,
                disabled: isModalSubmitting,
            }}
            isSmall={true}
        >
            {renderChildren()}
        </BaseModal>
    );
};

export default ManageFirmwareModal;
